module.exports = __webpack_public_path__ + "img/home_banner_3.ac25fc0b.png";